import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArticleItem from './ArticleItem';
import './ArticleList.css';

const ArticleList = ({ articles, isGridLayout, selectedCategory, user, loadMore, hasMore, isLoading }) => {
  const filteredArticles = selectedCategory
    ? articles.filter(article => article.category === selectedCategory)
    : articles;

  const displayedArticles = user ? filteredArticles : filteredArticles.slice(0, 10);

  return (
    <div className="article-list-container">
      {user ? (
        <InfiniteScroll
          dataLength={displayedArticles.length}
          next={loadMore}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
        >
          <div className={`article-list ${isGridLayout ? 'grid-layout' : 'vertical-layout'}`}>
            {displayedArticles.map(article => (
              <div key={article.id} className="article-wrapper">
                <ArticleItem
                  article={article}
                  user={user}
                />
              </div>
            ))}
          </div>
        </InfiniteScroll>
      ) : (
        <div className={`article-list ${isGridLayout ? 'grid-layout' : 'vertical-layout'}`}>
          {displayedArticles.map(article => (
            <div key={article.id} className="article-wrapper">
              <ArticleItem
                article={article}
                user={user}
              />
            </div>
          ))}
        </div>
      )}
      {isLoading && <div>Loading...</div>}
      {!user && (
        <div className="sign-in-banner">
          <span className="lock-icon">🔒</span>
          <p>Sign in to see more articles and unlock features</p>
        </div>
      )}
    </div>
  );
};

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string,
    url: PropTypes.string,
    source: PropTypes.string,
    category: PropTypes.string,
    date_added: PropTypes.string,
    importance_score: PropTypes.number
  })).isRequired,
  isGridLayout: PropTypes.bool.isRequired,
  selectedCategory: PropTypes.string,
  user: PropTypes.object,
  loadMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ArticleList;